import { Injectable } from '@angular/core';

import { ApiService } from '../../../../../common/services/api.service';
import { environment } from 'src/environments/environment';
import { apiEndPoints } from '../../../../../common/constants/api-endpointsconstant';
import { ReportService } from 'src/app/reports/services/report.service';

@Injectable({
  providedIn: 'root'
})
export class POCReportService {

  constructor(
    private apiServive: ApiService,
    private reportService: ReportService
  ) { }

    getTotalLandProperty() {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.houseVillasSummary}${changeParams}`;
    return this.apiServive.get(url);
  }

  getResidentialLandSupplyChart() {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.houseVillaGraph}${changeParams}`;
    return this.apiServive.get(url);
  }

  
  getIndependentHouseVillas(payload: any) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year = this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let offset = payload.pageNumber || 0
    let url: string = `${environment.miUrl}${apiEndPoints.independentHouseVillas}${changeParams}&limit=${payload?.pageSize}&offset=${offset}`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    if (offset == 0) {
      url += "&is_count=true"
    }
    return this.apiServive.get(url);
  }

  getGovernorHouseVillas(payload: any) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year =  this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let offset = payload.pageNumber || 0;

    let url: string = `${environment.miUrl}${apiEndPoints.governorHouseVillas}${changeParams}&limit=${payload.pageSize}&offset=${offset}&is_count=true`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    return this.apiServive.get(url);
  }

  getProjects(payload: any) {
    let queryParams = { ...this.reportService.queryParams };
    if (queryParams?.year) {
      queryParams.year =   this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let offset = payload.pageNumber || 0;

    let url: string = `${environment.miUrl}${apiEndPoints.projectHouseVillas}${changeParams}&limit=${payload.pageSize}&offset=${offset}&is_count=true`;
    if (payload.sort_order) {
      url += `&sort_order=${payload.sort_order}`;
    }
    return this.apiServive.get(url);
  }

   downloadHouseVillaReport(type: string, user_id: any, puId?: any) {
      const filterQueryParams = this.reportService.filterQueryParams;
      const params = new URLSearchParams(filterQueryParams);
      const yearFromQuery = params.get('year');
      const resultFilterQueryParams = filterQueryParams.replace(/&?year=\d{4}/, "");
      let url: string = `${environment.miUrl}${apiEndPoints.downloadHouseVillaReport}${resultFilterQueryParams}&type=${type}&user_id=${user_id}`;
      url += `&year=${this.reportService.yearMaxValue(yearFromQuery)}` ;
    
      if(puId){
        url += `&project_uid=${puId}`
      }
      return this.apiServive.get(url);
    }

   downloadExcelUrl(){
    return `${environment.miUrl}${apiEndPoints.downloadExcel}`;
  }

 }
